import "./EngineeringCalculations.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import CalculationsHero from "./sections/CalculationsHero";
import Calculations from "./sections/Calculations";
import WovenCalculations from "./sections/WovenCalculations";
import UnitConverter from "./sections/UnitConverter";
import FilterMedia from "./sections/FilterMedia";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function EngineeringCalculationsPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="EngineeringCalculations" />
      <CalculationsHero />
      <Calculations />
      <WovenCalculations />
      <UnitConverter />
      <FilterMedia />
      <ClosingCta />
      <Footer />
    </div>;
}